module.exports = require("@leafygreen-ui/palette");